import {
  PrivateLessonRequest,
  PrivateLessonRequestFilter,
  UpdatePrivateLessonRequestStatusRequest,
} from '../types/privateLessonRequest';
import api from './authService';

export const privateLessonRequestService = {
  async getRequests(status: PrivateLessonRequestFilter = 'Pending'): Promise<PrivateLessonRequest[]> {
    const response = await api.get('/private-lesson-requests', {
      params: { status },
    });
    return response.data.data || response.data;
  },

  async getPendingCount(): Promise<number> {
    const response = await api.get('/private-lesson-requests/pending-count');
    const data = response.data.data || response.data;
    return data.pendingCount;
  },

  async updateStatus(
    privateLessonRequestId: string,
    request: UpdatePrivateLessonRequestStatusRequest
  ): Promise<PrivateLessonRequest> {
    const response = await api.put(`/private-lesson-requests/${privateLessonRequestId}/status`, request);
    return response.data.data || response.data;
  },
};

export default privateLessonRequestService;
